/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Empty_StateInputs */

const en_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No terms yet. Click "Add Term" to create your first term.`)
};

const fr_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun terme pour le moment. Cliquez sur « Ajouter un terme » pour créer votre premier terme.`)
};

const de_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Termine. Klicken Sie auf „Termin hinzufügen“, um Ihren ersten Termin zu erstellen.`)
};

const it_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun termine ancora. Fai clic su "Aggiungi termine" per creare il tuo primo termine.`)
};

const ru_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет свободных сроков. Нажмите «Добавить срок», чтобы создать свой первый срок.`)
};

const es_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay términos. Haz clic en "Añadir término" para crear el primero.`)
};

const zh_cn2_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无条款。点击“添加条款”创建您的第一个条款。`)
};

const ja_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ用語がありません。最初の用語を作成するには、「用語を追加」をクリックしてください。`)
};

const hi_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई टर्म नहीं है। अपना पहला टर्म बनाने के लिए "टर्म जोड़ें" पर क्लिक करें।`)
};

const pt_pt2_knp_terms_empty_state = /** @type {(inputs: Knp_Terms_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não existem termos. Clique em "Adicionar termo" para criar seu primeiro termo.`)
};

/**
* | output |
* | --- |
* | "No terms yet. Click \"Add Term\" to create your first term." |
*
* @param {Knp_Terms_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_empty_state = /** @type {((inputs?: Knp_Terms_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_empty_state(inputs)
	if (locale === "de") return de_knp_terms_empty_state(inputs)
	if (locale === "it") return it_knp_terms_empty_state(inputs)
	if (locale === "ru") return ru_knp_terms_empty_state(inputs)
	if (locale === "es") return es_knp_terms_empty_state(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_empty_state(inputs)
	if (locale === "ja") return ja_knp_terms_empty_state(inputs)
	if (locale === "hi") return hi_knp_terms_empty_state(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_empty_state(inputs)
	return en_knp_terms_empty_state(inputs)
});